<app-navbar-style-two></app-navbar-style-two>

<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2 class="font-family005">Solutions</h2>
            <ul class="font-family005">
                <li><a routerLink="/"><i class="bx bx-home"></i> Home</a></li>
                <li class="active">Solutions / Enterprise solutions</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Services Details Area -->
<section class="services-details-area pt-5 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-content">
                    <h2 class="text-capitalize font-family005">Enterprise Solutions</h2>
                    <div class="services-content">
                         <div class="services-details-one">
                            <div class="row match-height">
                                <div class="col-12 col-md-6">
                                    <img src="assets/img/product/erpmain.png" alt="Image" class="fix img-thumbnail">
                                </div>
                                <div class="col-12 col-md-6">
                                    <div class="row match-height">
                                        <div class="col-12">
                                            <img src="assets/img/product/erp1.jpg" alt="Image" class="fix img-thumbnail">
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <img src="assets/img/product/erp3.jpg" alt="Image" class="fix img-thumbnail">
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <img src="assets/img/product/erp.jpg" alt="Image" class="fix img-thumbnail">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p class="font-family004 pt-3">An enterprise solution is a software application designed to meet the multifaceted needs of an organization rather than an individual end user or small business. Being large organizations with broad ranges or operations, enterprises often face unique challenges, such as interdepartmental communication and international commerce.</p>
                    </div>

                    <div class="services-content">
                        <h3 class="font-family005 mb-0">Enterprise Solution-Uses</h3>
                        <p class="font-family004">
                            One of the primary advantages of using an enterprise solution is that it can help track data throughout an organization. Broad access to data is important in numerous roles and for various purposes. Payroll, for example, involves visibility into salary records for all of an organization's employees. An enterprise solution makes sure that type of data is accessible to those who require it, helping to ensure a smooth-running operation.
                        </p> 
                    </div>

                    <div class="services-content">
                        <h3 class="font-family005 mb-0">Our Work in Enterprise Solutions</h3>
                         <p class="font-family004">ERP-Enterprise resource planning, or ERP, 
                            refers to a solution that integrates multiple essential processes within an organization,
                             namely those relating to accounting, inventory and supply chain management.
                              With an ERP tool, an enterprise can maintain relevant data in a central database where leaders
                               and other decision-makers can access it as required. The software also allows for the automation 
                               of repeatable workflows, thus improving operational efficiency.</p> 
                        <p class="font-family004">SCM-Supply chain management is the process and practice of overseeing all of the steps involved in creating a product and delivering it to the customer. The process includes devising product ideas, acquiring raw materials necessary for a product's creation, moving and storing these materials, receiving orders that initiate production, storing finished goods and transporting them to their destinations.
                        </p>    
                           <p class="font-family004">HRMS-HR software is a digital solution for managing and optimizing the daily human resources tasks and overall HR goals of an organization. HR software makes it possible for HR staff and managers to better allocate their time and resources to more productive, profitable efforts.
                           </p>
                        <p class="font-family004">SmartCity(Video Surveilance)Centralised Recording of the video footages in the District Managers Office.The live Video Footages are transferred from cameras in the shop to the Network Video Recorder in the District Manager Office through Internet (IPv6). It is the first of its kind in India using IPv6 Network. Monitoring Centres at Regional Offices and Head Quarters of TASMAC.
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-sidebar">
                    <div class="services-category">
                        <ul class="font-family004">
                            <li><a routerLink="/smart-card">Smart Card Solutions <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/smart-city">Smart City and Safe City <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/vr-ar">VR / AR <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/enterprise-soln">Enterprise Solutions <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/marketing-soln">Marketing Solutions <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/web-app">Web / Mobile App <i class="bx bx-chevron-right"></i></a></li>
                            <!-- <li><a routerLink="/services-details">Penetration Testing <i class="bx bx-chevron-right"></i></a></li> -->
                        </ul>
                    </div>

                    <div class="services-pdf">
                        <ul class="font-family005">
                            <li><a href="assets/img/BT-CP.pdf"><i class="bx bxs-file-pdf"></i> Company Profile</a></li>
                            <!-- <li><a routerLink="/"><i class="bx bxs-file-doc"></i> DOC Download</a></li> -->
                        </ul>
                    </div>

                    <div class="services-contact mb-30">
                        <h3 class="font-family003">Contact us to do your new projects</h3>
                        <a routerLink="/contact" class="default-btn font-family005"><span>Contact Us</span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details Area -->

